import { GivenAnswer, GivenAnswerProps } from "../models/GivenAnswer"
import { makeAutoObservable, toJS } from "mobx"

export class GivenAnswerList {
  items: GivenAnswer[]

  constructor(props: GivenAnswerProps[]) {
    makeAutoObservable(this, {}, { autoBind: true })
    this.items = props.map((p) => new GivenAnswer(p))
  }

  emptyOptionalAnswers(givenAnswer) {
    return givenAnswer.question?.optional && !givenAnswer.hasAnswer()
  }

  toJS(): any[] {
    return toJS(this.items.filter((ga) => !this.emptyOptionalAnswers(ga)))
  }
}
